// data/AppDev/AppDevSkillsetData.js
// `visual` selects a pure-CSS/animated element from SkillsetVisual.jsx
// instead of a stock image — see src/components/SkillSetSection/SkillsetVisual.jsx.
const appSkillsets = [
  {
    id: 1,
    visual: "automation",
    title: "Skalierbare Architektur & Cloud-Integration",
    description:
      "Wir konzipieren Apps mit einer hochskalierbaren Backend-Architektur und integrieren Cloud-Plattformen wie AWS, Azure oder GCP. So bleibt Ihre Anwendung auch bei steigenden Nutzerzahlen zuverlässig und performant. Mit Microservices, Docker und Kubernetes sorgen wir für maximale Flexibilität und Ausfallsicherheit.",
  },
  {
    id: 2,
    visual: "terminal",
    title: "Moderne Frameworks & Programmiersprachen",
    description:
      "Ob React Native, Flutter oder native Entwicklung in Swift und Kotlin: Wir setzen aktuelle Technologien ein, um reaktionsschnelle, stabile und wartungsfreundliche Apps zu entwickeln. Dabei folgen wir Clean-Code-Prinzipien und nutzen TypeScript, Node.js oder Python für eine robuste, testbare und zukunftssichere Codebasis.",
  },
  {
    id: 3,
    visual: "dashboard",
    title: "Sicherheit, Qualitätssicherung & Wartung",
    description:
      "Von der Authentifizierung über Datenverschlüsselung bis zur DSGVO-Konformität: Wir integrieren bewährte Sicherheitsmechanismen, damit Ihre App und die Daten Ihrer Nutzer geschützt sind. Automatisierte Tests, Continuous Integration und regelmäßige Updates halten Ihre Anwendung stabil – auf Wunsch mit langfristigem Support.",
  },
];

export default appSkillsets;
